import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "form-group"
}
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "text-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_ctx.acquistiInAttesa.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Hai già un acquisto in attesa di essere confermato",
            text: "Hai già un acquisto in attesa di essere confermato"
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Completalo, prima di iniziarne altri",
            text: "Completalo, prima di iniziarne altri"
          })
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_localized_text, {
            localizedKey: "Troverai le istruzioni per il pagamento nella tua home dopo aver premuto su Conferma",
            text: "Troverai le istruzioni per il pagamento nella tua home dopo aver premuto su Conferma"
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('pay')))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Conferma pagamento!",
              text: "Conferma pagamento!"
            })
          ])
        ])
      ]))
}